import { useTranslation } from 'react-i18next';

import { cn } from '@/utils';

function EmptySection({ className }) {
	const { t } = useTranslation();

	return (
		<div
			className={cn(
				'flex min-h-[92px] flex-col items-center justify-center gap-2 rounded bg-grey-100 px-6',
				className
			)}
		>
			<div className="self-stretch text-center text-xs font-normal leading-tight text-grey-500">
				{t(`billing.subscription.empty`)}
			</div>
		</div>
	);
}

export default EmptySection;
